import { InjectionToken } from '@angular/core';

export const SN_BRAND_NAME = new InjectionToken<string>('SN_BRAND_NAME');
